import * as React from 'react';
import { useSelector } from 'react-redux';

import { EValuationTrap } from 'shared/containers/valuationTraps/CPDTrapContainer/CPDBannerTrap/types';
import { isNewbuildingSelector, selectIsAgent, selectIsOfferOwnedByUser } from 'shared/selectors';
import { selectCPDTrapGroup } from 'shared/selectors/abExperiments/selectCPDTrapGroup';
import { selectIsCpdAvailable } from 'shared/selectors/cpd/cpd';
import { isSuburbanSelector } from 'shared/selectors/suburban/isSuburbanSelector';

export const useCpdOrCplTrapVisible = (): EValuationTrap | null => {
  const [trap, setTrap] = React.useState<EValuationTrap | null>(null);

  const isCpdAvailable = useSelector(selectIsCpdAvailable);

  const isAgent = useSelector(selectIsAgent);
  const isOfferByUser = useSelector(selectIsOfferOwnedByUser);
  const isSuburban = useSelector(isSuburbanSelector);
  const isNewbuilding = useSelector(isNewbuildingSelector);

  const experimantGroup = useSelector(selectCPDTrapGroup);

  React.useEffect(() => {
    if (isCpdAvailable && !isNewbuilding && !isOfferByUser && !isAgent && experimantGroup === 'control') {
      setTrap(EValuationTrap.cpd);

      return;
    }

    if (!isSuburban) {
      setTrap(EValuationTrap.cpl);

      return;
    }

    return;
  }, [isCpdAvailable, isNewbuilding, isSuburban, isOfferByUser, isAgent]);

  return trap;
};
